import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import React from 'react';
import styled from 'styled-components';
import { formatDateTime } from 'utils/formatters';
import { Text } from 'styles/themeColors';
import { Space } from 'styles/themeSpaces';
import AIBrainIcon from '../../images/AI_Brain_Icon.gif';

import {
  UploadingStatus,
} from './ProductVariantImportModal';
import {
  STATUS,
  STEPS,
  TEXT_LABELS,
} from '../../constants/productVariantImport';
import Spinner from 'components/UI/Spinner';
const ColumnName = styled.div`
  width: 80px;
  font-size: ${Space.sp2x};
  line-height: 24px;
  color: ${Text.primary};
  padding-top: ${Space.spHalf};
  margin-right: ${Space.sp3x};
`;

const ColumnValue = styled.div<any>`
  font-size: ${Space.sp2x};
  line-height: 20px;
  background-color: ${({ $bgcolor }) => ($bgcolor ? $bgcolor : 'transparent')};
  padding: ${({ $padding }) => ($padding ? $padding : '0px')};
  color: ${({ $color }) => ($color ? $color : Text.primary)};
  font-weight: ${({ $weight }) => ($weight ? $weight : '400')};
  border-radius: 6px;
  margin: ${({ margin }) => (margin ? margin : '0px')};
`;
interface Props {
  uploadingStatus: UploadingStatus | undefined;
  step: number;
  progressPercent?: number;
  progressMessage?: string;
  importedLabel?: string;
  failedLabel?: string;
  isGenAI?: boolean;
}
export default function VerificationAndCompletionComponent({
  uploadingStatus,
  step,
  progressPercent,
  progressMessage,
  importedLabel = TEXT_LABELS.VARIANTS_IMPORT,
  failedLabel = TEXT_LABELS.VARIANTS_FAILED,
  isGenAI,
}: Props) {
  return (
    <FlexboxContainerComponent flexDirection="column" margin="32px 0px 0px 0px">
      {uploadingStatus ? isGenAI ?
        <FlexboxContainerComponent flexDirection="row" margin='20px 0px' justifyContent='center'>
          {step === STEPS.COMPLETION ?
            <ColumnValue
              $bgcolor={
                uploadingStatus?.totalCount === uploadingStatus?.passedCount
                  ? '#2CAE44'
                  : !uploadingStatus?.passedCount
                    ? '#C82135'
                    : '#FFC107'
              }
              $weight="700"
              $padding="4px"
              $color="#FFFFFF"
            >
              <div style={{ textAlign: 'center' }}>
                {uploadingStatus?.totalCount === uploadingStatus?.passedCount
                  ? TEXT_LABELS.PROCESSING_COMPLETED
                  : !uploadingStatus?.passedCount
                    ? TEXT_LABELS.PROCESSING_FAILED
                    : TEXT_LABELS.PARTIAL_SUCCESS}
              </div>
            </ColumnValue> : <></>
          }
        </FlexboxContainerComponent> : (
          <FlexboxContainerComponent flexDirection="column" gap='4px'>
            <FlexboxContainerComponent alignItems="center" flexDirection="row">
              <ColumnName>{TEXT_LABELS.FILENAME}</ColumnName>
              <ColumnValue>{uploadingStatus.fileName}</ColumnValue>
            </FlexboxContainerComponent>
            <FlexboxContainerComponent alignItems="center" flexDirection="row">
              <ColumnName>{TEXT_LABELS.UPLOADED}</ColumnName>
              <ColumnValue>
                {formatDateTime(uploadingStatus?.createdOn, true)}
              </ColumnValue>
            </FlexboxContainerComponent>
            <FlexboxContainerComponent flexDirection="row">
              <ColumnName>{TEXT_LABELS.STATUS}</ColumnName>
              {step === STATUS.COMPLETED ? (
                <ColumnValue flexDirection="col" >
                  <div>
                    {progressPercent}{TEXT_LABELS.PERCENT_VERIFIED}{' '}
                  </div>
                  <div className="progress-bar" style={{ minWidth: '150px' }}>
                    <progress value={progressPercent} max={100} />
                  </div>
                </ColumnValue>
              ) : (
                <ColumnValue
                  $bgcolor={
                    uploadingStatus?.totalCount === uploadingStatus?.passedCount
                      ? '#2CAE44'
                      : !uploadingStatus?.passedCount
                        ? '#C82135'
                        : '#FFC107'
                  }
                  $weight="700"
                  $padding="4px"
                  $color="#FFFFFF"
                >
                  {uploadingStatus?.totalCount === uploadingStatus?.passedCount
                    ? TEXT_LABELS.COMPLETED
                    : !uploadingStatus?.passedCount
                      ? TEXT_LABELS.VERIFICATION_FAILED
                      : TEXT_LABELS.PARTIAL_SUCCESS}
                </ColumnValue>
              )}
            </FlexboxContainerComponent>
            {step === STEPS.COMPLETION && (
              <FlexboxContainerComponent alignItems="center" flexDirection="row">
                <ColumnName>{importedLabel}</ColumnName>
                <ColumnValue>{uploadingStatus?.passedCount}</ColumnValue>
              </FlexboxContainerComponent>
            )}

            {step === STEPS.COMPLETION && (
              <FlexboxContainerComponent alignItems="center" flexDirection="row">
                <ColumnName>{failedLabel}</ColumnName>
                <ColumnValue>{uploadingStatus?.failedCount}</ColumnValue>
              </FlexboxContainerComponent>
            )}
          </FlexboxContainerComponent>
        ) : (
        <FlexboxContainerComponent flexDirection="column" alignItems="center">
          <FlexboxContainerComponent flexDirection="row" justifyContent="center">
            {isGenAI ? <img src={AIBrainIcon} alt="Some AI going on..." width="120" /> : <Spinner />}
          </FlexboxContainerComponent>
          {isGenAI && progressPercent !== undefined && progressPercent > 0 && (
            <FlexboxContainerComponent flexDirection="column" padding="16px 0" width="400px">
              <FlexboxContainerComponent flexDirection="row" justifyContent="space-between" alignItems="center" margin="0 0 8px 0">
                <ColumnValue>{progressMessage || TEXT_LABELS.PRODUCT_BROCHURE_PARSING}</ColumnValue>
                <ColumnValue>{progressPercent}%</ColumnValue>
              </FlexboxContainerComponent>
              <div className="progress-bar">
                <progress value={progressPercent} max={100} />
              </div>
            </FlexboxContainerComponent>
          )}
        </FlexboxContainerComponent>
      )}
    </FlexboxContainerComponent>
  );
}
